import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from '../components/LegalLayout';

const PrivacyPolicy: React.FC = () => (
  <LegalLayout title="Informativa sulla Privacy" lastUpdated="17 giugno 2026">
    <p>
      La presente informativa è resa ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679
      («GDPR») e del D.lgs. 196/2003 (Codice Privacy) e descrive come vengono trattati i dati
      personali degli utenti che consultano il sito ChatLy (il «Sito») e che utilizzano l'assistente
      conversazionale ChatLy su WhatsApp (il «Servizio»).
    </p>

    <h2>1. Titolare del trattamento</h2>
    <p>
      Il Titolare del trattamento è <strong>Alessio Di Como – Delta Code</strong>, con sede in Via
      di Sant'Alessio 39, 51100 Pistoia (PT), Italia — P.IVA 02138520479.
    </p>
    <p>
      Per qualsiasi richiesta relativa al trattamento dei dati personali è possibile scrivere a{' '}
      <a href="mailto:info@chatly.it">info@chatly.it</a> oppure a{' '}
      <a href="mailto:info@deltacode.it">info@deltacode.it</a>. Non è stato nominato un Responsabile
      della Protezione dei Dati (DPO).
    </p>

    <h2>2. Tipologie di dati trattati</h2>
    <h3>a) Dati di navigazione del Sito</h3>
    <p>
      I sistemi informatici e le procedure preposte al funzionamento del Sito acquisiscono, nel corso
      del loro normale esercizio, alcuni dati la cui trasmissione è implicita nell'uso dei protocolli
      di Internet. Si tratta in particolare di:
    </p>
    <ul>
      <li>indirizzo IP e dati del dispositivo (tipo di browser, sistema operativo);</li>
      <li>pagine visitate, data, ora e durata della visita, provenienza (referrer);</li>
      <li>identificatori dei cookie analitici, esclusivamente previo consenso.</li>
    </ul>
    <p>
      Questi dati sono utilizzati per ricavare informazioni statistiche in forma aggregata sull'uso
      del Sito e per garantirne la sicurezza e il corretto funzionamento.
    </p>

    <h3>b) Dati relativi al Servizio ChatLy su WhatsApp</h3>
    <p>
      I pulsanti di contatto presenti sul Sito reindirizzano a WhatsApp; il Sito non raccoglie dati
      tramite moduli di contatto. Nell'ambito dell'utilizzo del Servizio possono essere trattati il
      numero di telefono, il nome profilo e il contenuto dei messaggi scambiati con l'assistente. La
      messaggistica avviene tramite l'infrastruttura di WhatsApp (Meta), soggetta alla relativa{' '}
      <a href="https://www.whatsapp.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">
        informativa privacy
      </a>
      .
    </p>

    <h2>3. Finalità e basi giuridiche</h2>
    <ul>
      <li>
        <strong>Fornitura del Servizio</strong> e riscontro alle richieste degli utenti — esecuzione
        di un contratto o di misure precontrattuali (art. 6, par. 1, lett. b, GDPR).
      </li>
      <li>
        <strong>Sicurezza e corretto funzionamento del Sito</strong> — legittimo interesse del
        Titolare (art. 6, par. 1, lett. f, GDPR).
      </li>
      <li>
        <strong>Statistiche e analisi dell'uso del Sito</strong> tramite Google Analytics —{' '}
        <strong>consenso</strong> dell'interessato (art. 6, par. 1, lett. a, GDPR), revocabile in
        qualsiasi momento.
      </li>
      <li>
        <strong>Adempimento di obblighi di legge</strong> — art. 6, par. 1, lett. c, GDPR.
      </li>
    </ul>

    <h2>4. Cookie e strumenti di tracciamento</h2>
    <p>
      Il Sito utilizza cookie tecnici e, previo consenso, cookie analitici. Non sono utilizzati
      cookie di profilazione o di marketing. Per il dettaglio delle finalità, della durata e delle
      modalità di gestione del consenso consulta la{' '}
      <Link to="/cookie-policy">Cookie Policy</Link>.
    </p>

    <h2>5. Destinatari e responsabili del trattamento</h2>
    <p>
      I dati possono essere trattati, per conto del Titolare e in qualità di responsabili del
      trattamento ai sensi dell'art. 28 GDPR, da fornitori di servizi tecnologici che assistono nel
      funzionamento del Sito e del Servizio, tra cui:
    </p>
    <ul>
      <li><strong>Google Ireland Ltd. / Google LLC</strong> — servizio di analisi Google Analytics 4;</li>
      <li><strong>Meta Platforms Ireland Ltd.</strong> — messaggistica WhatsApp;</li>
      <li><strong>Vercel Inc.</strong> — hosting e distribuzione del Sito.</li>
    </ul>
    <p>
      I dati non sono oggetto di diffusione e non sono ceduti a terzi per finalità di marketing.
    </p>

    <h2>6. Trasferimenti di dati extra-UE</h2>
    <p>
      Alcuni fornitori (Google, Meta, Vercel) possono trattare dati anche al di fuori dello Spazio
      Economico Europeo, in particolare negli Stati Uniti. Tali trasferimenti avvengono sulla base
      della decisione di adeguatezza «EU-US Data Privacy Framework» e/o delle Clausole Contrattuali
      Tipo (SCC) adottate dalla Commissione Europea, integrate ove necessario da misure
      supplementari. Si segnala che il Garante per la protezione dei dati personali, con
      provvedimento del giugno 2022, ha rilevato criticità relative ai trasferimenti verso gli USA
      effettuati tramite Google Analytics: per questo il Titolare adotta l'anonimizzazione
      dell'indirizzo IP, la minimizzazione dei dati e subordina l'attivazione degli strumenti
      analitici al consenso dell'utente.
    </p>

    <h2>7. Periodo di conservazione</h2>
    <ul>
      <li>
        Dati di navigazione: per il tempo strettamente necessario alle finalità di sicurezza e
        statistica;
      </li>
      <li>
        Dati di Google Analytics: secondo le impostazioni del servizio (di norma fino a 14 mesi); i
        relativi cookie hanno durata massima di circa 13 mesi;
      </li>
      <li>
        Dati delle conversazioni WhatsApp: per il tempo necessario a gestire la richiesta e secondo
        quanto indicato nella pagina <Link to="/eliminazione-dati">Eliminazione Dati</Link>.
      </li>
    </ul>
    <p>Decorsi tali termini, i dati sono cancellati o resi anonimi.</p>

    <h2>8. Diritti dell'interessato</h2>
    <p>Ai sensi degli articoli 15-22 del GDPR, hai il diritto di ottenere:</p>
    <ul>
      <li>l'<strong>accesso</strong> ai tuoi dati personali (art. 15);</li>
      <li>la <strong>rettifica</strong> dei dati inesatti (art. 16);</li>
      <li>la <strong>cancellazione</strong> dei dati («diritto all'oblio», art. 17);</li>
      <li>la <strong>limitazione</strong> del trattamento (art. 18);</li>
      <li>la <strong>portabilità</strong> dei dati (art. 20);</li>
      <li>l'<strong>opposizione</strong> al trattamento (art. 21);</li>
      <li>
        la <strong>revoca del consenso</strong> in qualsiasi momento, senza pregiudicare la liceità
        del trattamento effettuato prima della revoca.
      </li>
    </ul>

    <h2>9. Esercizio dei diritti e reclamo</h2>
    <p>
      Per esercitare i tuoi diritti puoi scrivere a <a href="mailto:info@chatly.it">info@chatly.it</a>.
      Hai inoltre il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati
      personali (
      <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">
        www.garanteprivacy.it
      </a>
      ).
    </p>

    <h2>10. Modifiche all'informativa</h2>
    <p>
      Il Titolare si riserva di aggiornare la presente informativa per adeguarla a novità normative o
      a modifiche del Servizio. Le variazioni saranno pubblicate su questa pagina con indicazione
      della data di ultimo aggiornamento.
    </p>
  </LegalLayout>
);

export default PrivacyPolicy;
